import { Component, SecurityContext } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { take } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Console } from 'console';

@Component({
  selector: 'user-profile',
  templateUrl: './userProfile.component.html'
})

export class UserProfileComponent {

  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService,
    private san: DomSanitizer,
    private auth: AuthService) { }

  s = this.san;
  secCon = SecurityContext;

  //***************************
  // Variables
  //***************************
  user: any;

  defaultSiteId: number;
  defaultPaySiteId: number;
  defaultFacilitiesGrid: string;
  defaultInventoryGrid: string;
  sig: any;
  defaultSchedulerView: string;
  workSectionId: number;
  defaultWorkSectionId: number | null;  
  
  // fake filename for file upload component
  sigName:string;

  //Dropdown Values
  sitesValues = this.transferHttp.getSingle('User/GetAllSites');
  workSectionValues = this.transferHttp.getSingle('User/GetWorkSections');
  
  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  //***************************
  // Functions
  //***************************

  saveDefaults() {
    this.spinnerText = "Saving...";
    this.showSpinner = true;    

    this.transferHttp.put('User/SaveDefaults?empId='
      + this.user.employeeId + "&defaultPaySiteId="
      + this.defaultPaySiteId + "&defaultSiteId="
      + this.defaultSiteId + "&defaultFacilitiesGrid="
      + this.defaultFacilitiesGrid + "&defaultSchedulerView="
      + this.defaultSchedulerView + "&defaultInventoryGrid="
      + this.defaultInventoryGrid + "&defaultWorkSectionId="
      + this.defaultWorkSectionId, null).pipe(take(1))
      .subscribe(done => {
        this.auth.doLoginUser();
        this.showSpinner = false;
      });
  }

  sigChanged() {
    // null out signature vars, as loadProfile will not overwrite if no signature
    this.sig = null;
    this.sigName = null;
    this.loadProfile();
  }

  loadProfile() {
    this.transferHttp.getSingle(`User/GetEmployee`).subscribe(u => {
      this.user = u;
      this.defaultPaySiteId = u.defaultPaySiteId;
      this.defaultSiteId = u.defaultSiteId;
      this.defaultFacilitiesGrid = u.defaultFacilitiesGrid;
      this.defaultInventoryGrid = u.defaultInventoryGrid;
      this.defaultSchedulerView = u.defaultSchedulerView;
      this.defaultWorkSectionId = u.defaultWorkSectionId;      
      
      if (u.employeeSignature) {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
          this.sig = reader.result;
          this.sigName = "signature";
        }, false);

        if (u.employeeSignature) {
          var binary = atob(u.employeeSignature);
          var len = binary.length;
          var buffer = new ArrayBuffer(len);
          var view = new Uint8Array(buffer);
          for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
          }
          reader.readAsDataURL(new Blob([view]));
        }
      }

      this.showSpinner = false;
    });

  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.loadProfile();
  }

}
